import { createApi } from '@reduxjs/toolkit/query/react';
import { MOELoginFetchBase } from '~/api/baseFetch';
import { TMOELoginPayload, TMOELoginResponse } from './MOELogin.type';

export const MOELoginApi = createApi({
  reducerPath: 'MOELoginApi',
  baseQuery: MOELoginFetchBase,
  endpoints: builder => ({
    getMOELoginUrl: builder.query<TMOELoginResponse, TMOELoginPayload>({
      query: data => ({
        url: null,
        body: data,
      }),
    }),
  }),
});

export const { useGetMOELoginUrlQuery } = MOELoginApi;
